import React from 'react';
import Tasks from './components/tasks/Tasks';
import { renderComponent } from 'utils/commonUtils';

const TaskManagement = () => {
  return renderComponent(<Tasks />);
};

export default TaskManagement;
